import { useQuery } from "@tanstack/react-query";
import networkApi from "../../network/api";
import useGraphPagination from "./useGraphPagination";

const useInitNetworkReferences = (
  networkReferences?: Array<string>,
  count?: number
) => {
  const {
    data: pagedNetworkDataReferences,
    goToNext: loadMoreNetworkReferences,
    currentPageData
  } = useGraphPagination(networkReferences ?? [], { pageSize: 20 });

  const getUrlReputationData = () =>
    networkApi.urlReputation(pagedNetworkDataReferences);

  const { data: networkRepData, isFetching } = useQuery({
    queryKey: ["networkReputation", currentPageData.page],
    queryFn: getUrlReputationData,
    select: ({ data }) => data.entries,
    enabled: Boolean(pagedNetworkDataReferences?.length),
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });

  return {
    data: {
      networkRepData
    },
    counts: {
      totalNetworkReferences: count ?? 0
    },
    actions: { loadMoreNetworkReferences },
    isFetching
  };
};

export default useInitNetworkReferences;
